import React from 'react';
import styles from './OverlapImagesHero.module.css';

const OverlapImagesHero = ({ title, paragraphs, overlayImage, mainImage }) => (
  <section className={styles.aboutContainer}>
    <div className={styles.imageSection}>
      <div className={styles.overlayImageWrapper}>
        <img src={overlayImage.src} alt={overlayImage.alt} className={styles.displayImage} />
      </div>
      <div className={styles.mainImageWrapper}>
        <img src={mainImage.src} alt={mainImage.alt} className={styles.displayImage} />
      </div>
    </div>
    <div className={styles.contentSection}>
      <h1 className={styles.title}>{title}</h1>
      {paragraphs.slice(0, 2).map((paragraph, index) => (
        <p key={index} className={styles.paragraph}>
          {paragraph}
        </p>
      ))}
    </div>
  </section>
);

export default OverlapImagesHero;
